import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';
import {toFormikValidationSchema} from 'zod-formik-adapter';

import {FormWithButtons} from '@flexinet/ui-components';

import {
    CustomerSubscription,
    CustomerSubscriptionStatus,
} from '../types';

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<CustomerSubscription, 'id'>,
    handleSubmit: (values: CustomerSubscription) => void,
    handleCancel?: () => void
}) => {

    const onSubmit = (values: CustomerSubscription) => {
        handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };

    let initialValues = {
        customerId: record.customerId || '',
        items: {items: [], nextToken: undefined},
        status: CustomerSubscriptionStatus.Active
    } as unknown as CustomerSubscription;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={toFormikValidationSchema(RecordSchema)}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
